// src/components/filter.
import React, { useEffect, useState } from "react";
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';

import {
    Table,
    Col,
    Row,
    UncontrolledTooltip,
} from "reactstrap"
import { IoIosAdd } from "react-icons/io";
import MailPopupModal from "../MailPopup/MailPopup";



//import components
import Breadcrumbs from 'components/_Common/Breadcrumb';
import { useDispatch, useSelector } from "react-redux";

// actions
import { listRaters, viewParticipantProfile, viewProfile } from "store/actions";
import { withTranslation } from "react-i18next";


const List = props => {
    //meta title
    document.title = `${props.t("Raters Invitation")}`;

    const { error, success, loading } = useSelector(state => ({
        loading: state.RatersInvite.loading,
        error: state.RatersInvite.error,
        success: state.RatersInvite.success,
    }));


    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [modal, setModal] = useState(false);
    const [itemData, SetItemData] = useState();
    const [tableData, SetTableData] = useState([]);

    const toggle = () => {
        if (modal) {
            setModal(false);

        } else {
            setModal(true);
        }
    };

    // list
    const fetchlistRaters = (filterData) => {
        dispatch(listRaters(filterData, (res) => {
            if (res?.status === 'success') {
                SetTableData(res?.data)
                SetItemData({})
            }
        }))
    }
    useEffect(() => {
        fetchlistRaters()
    }, [])

    const [profileData, setProfileData] = useState()
    const fetchProfile = async () => {
        dispatch(viewProfile('survey/participant/auth/me', (res) => {
            setProfileData(res?.data)
        }));
    }

    useEffect(() => {
        fetchProfile()
    }, [])

    return (
        <React.Fragment>
            <div className="page-content">
                <div className="container-fluid">
                    <Breadcrumbs title={props.t("Raters Invite")} breadcrumbItem={props.t("Invitation")} />
                    <MailPopupModal
                        modal={modal}
                        toggle={toggle}
                        itemData={itemData}
                        profileData={profileData}
                        fetchlistRaters={() => fetchlistRaters()}
                    />
                    <Row>
                        <Col lg="12">
                            <div className="table-responsive rater-invite-list-table">
                                {
                                    loading ?
                                        <div className="loader d-flex justify-content-center align-items-center mt-5" >
                                            <i className="bx bx-loader bx-spin font-size-16 align-middle me-2"></i>{" "}
                                            {props.t("Loading")}
                                        </div>
                                        :
                                        <>
                                            <Table className="invitationtable_wrap table mb-0 invitation rater-invite">
                                                <thead>
                                                    <tr>
                                                        <th>{props.t("Rater Type")}</th>
                                                        <th>{props.t("Invite Sent")}</th>
                                                        <th>{props.t("Pending")}</th>
                                                        <th>{props.t("In-Progress")}</th>
                                                        <th>{props.t("Complete")}</th>
                                                        <th>{props.t("Total Invites")}</th>
                                                        <th>{props.t("Send")}</th>
                                                    </tr>
                                                </thead>
                                                {
                                                    tableData?.length <= 0 || tableData?.length == undefined
                                                        ?
                                                        <tr>
                                                            <td colSpan="5" className="text-center no-record-found">{props.t("No Record Found")}</td>
                                                        </tr>
                                                        :
                                                        <tbody>
                                                            {(tableData || []).map((item, index) => (
                                                                <tr key={index}>
                                                                    <td>{item?.rater_type?.split('_')
                                                                        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                                                                        .join(' ')}
                                                                    </td>
                                                                    <td>
                                                                        <UncontrolledTooltip
                                                                            placement="top"
                                                                            target={`invitationSentTooltip${item?.id}`}
                                                                        >
                                                                            The checkbox is triggered by the click action, not actual email delivery
                                                                        </UncontrolledTooltip>
                                                                        <label className="question-radio rater-invite-check">
                                                                            <input id={`invitationSentTooltip${item?.id}`} type="checkbox" readOnly checked={item?.invitations?.invite_sent == "yes" ? true : false} />
                                                                            <span className="question-radio-click"></span>
                                                                        </label>

                                                                    </td>
                                                                    <td>{item?.invitations?.pending || 0}</td>
                                                                    <td>{item?.invitations?.progress}</td>
                                                                    <td>{item?.invitations?.complete || 0}</td>
                                                                    <td>{item?.invitations?.total_invites || 0}</td>
                                                                    <td>
                                                                        <button
                                                                            onClick={() => {
                                                                                fetchProfile()
                                                                                setModal(true)
                                                                                SetItemData(item)
                                                                            }}
                                                                        >
                                                                            <IoIosAdd size={20} />
                                                                            {props.t("Mail")}
                                                                        </button>
                                                                    </td>
                                                                </tr>
                                                            ))}
                                                        </tbody>
                                                }
                                            </Table>
                                            <div className="footerNote">
                                                {/* The minimum requirements (e.g., 1 Boss, 3 Peers, 3 Direct Reports) and clarify optional categories like “Superior.” */}
                                                <h4>SCHOR 360 Participation Requirements and Rater Roles</h4>
                                                <p>
                                                    To generate a SCHOR 360 report, you must complete your self-assessment and receive ratings from at least one Boss, three Peers and three Direct Reports. You may invite additional raters for broader feedback. While Superior and Other categories are optional and do not count toward the minimum, including them is encouraged if relevant.
                                                </p>
                                                <h5>Rater Type Definitions</h5>
                                                <p>Please select the relationship type that best describes each person you invite:</p>
                                                <ul>
                                                    <li><b>Boss:</b> Your immediate supervisor (the person you report to directly).</li>
                                                    <li> <b>Superior:</b> Someone more senior than you who does <b>not</b> directly supervise your work.</li>
                                                    <li> <b>Peer:</b>  A colleague you work with who has <b>no supervisory relationship</b> with you.</li>
                                                    <li> <b>Direct Report:</b> Someone whose work you <b>supervise directly.</b></li>
                                                    <li> <b>Other:</b> Anyone outside the formal hierarchy—such as committee members, external collaborators, or former teammates.</li>
                                                </ul>
                                                <h5>System Behavior Note</h5>
                                                <p>
                                                    The “Invite Sent” checkbox is triggered when you click +Mail, even if no message is sent. Rater status will only update once they open the link included in the invite email that you sent and begin providing feedback. You won’t see who has or hasn’t responded, hence consider sending a general reminder to encourage completion.
                                                </p>
                                            </div>
                                        </>

                                }
                            </div>
                        </Col>
                    </Row>
                </div>
            </div>
        </React.Fragment>
    );
}

List.propTypes = {
    history: PropTypes.object,
    t: PropTypes.any,

};

export default withTranslation()(List);
